export { default as Img200 } from './processed/200/Into-The-Badlands-S2.jpg';
export { default as Img400 } from './processed/400/Into-The-Badlands-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Into-The-Badlands-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Into-The-Badlands-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Into-The-Badlands-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      204,
      5,
      28
    ],
    "_population": 7,
    "_hsl": [
      0.9807370184254607,
      0.9521531100478468,
      0.4098039215686275
    ]
  },
  "LightVibrant": {
    "_rgb": [
      208,
      143,
      152
    ],
    "_population": 797,
    "_hsl": [
      0.976923076923077,
      0.40880503144654085,
      0.6882352941176471
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      129,
      3,
      18
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      170,
      101,
      125
    ],
    "_population": 269,
    "_hsl": [
      0.9420289855072465,
      0.2887029288702928,
      0.5313725490196078
    ]
  },
  "LightMuted": {
    "_rgb": [
      176,
      164,
      204
    ],
    "_population": 2,
    "_hsl": [
      0.7166666666666667,
      0.2816901408450705,
      0.7215686274509805
    ]
  },
  "DarkMuted": {
    "_rgb": [
      62,
      52,
      94
    ],
    "_population": 7,
    "_hsl": [
      0.7063492063492064,
      0.28767123287671237,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Into-The-Badlands-S2.js